export default "__VITE_ASSET__489ba918__"